import React, { useState, useEffect } from "react";
import api from "../../utils/api";
import "./Terms.scss";
import Loader from "../../components/Loader/Loader";
import Logo from "./../../assets/images/MainLogo.svg";
import { useLanguage } from "../../context/LanguageContext";
// Import Material UI icons
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import GppGoodIcon from "@mui/icons-material/GppGood";
import ReplayIcon from "@mui/icons-material/Replay";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ArticleIcon from "@mui/icons-material/Article";

const Terms = () => {
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);
  const { language } = useLanguage();
  const isRTL = language === "ar";

  useEffect(() => {
    const fetchTermsConditions = async () => {
      setLoading(true);
      try {
        const response = await api.get("/system/terms-conditions");
        setTerms(response?.data?.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchTermsConditions();
  }, []);

  return (
    <div className={`terms ${isRTL ? "rtl" : "ltr"}`}>
      <div className="container">
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="terms-header">
              <img src={Logo} alt="Logo" className="logo" />
              <h1 className="title">
                {isRTL ? "الشروط والاحكام" : "Terms and Conditions"}
              </h1>
            </div>
            <div className="terms-content">
              {terms.map((term) => (
                <div key={term._id} className="term-item">
                  <div className="term-header">
                    <ArticleIcon className="term-icon" />
                    <h2 className="term-title">
                      {isRTL ? term.titleAr : term.titleEn}
                    </h2>
                  </div>
                  <div className="term-text-list">
                    {(isRTL ? term.textAr : term.textEn)
                      .split("\n")
                      .map((textItem, index) => {
                        // Select icon based on index
                        let ItemIcon;
                        switch (index) {
                          case 0:
                            ItemIcon = VerifiedUserIcon;
                            break;
                          case 1:
                            ItemIcon = GppGoodIcon;
                            break;
                          case 2:
                            ItemIcon = ReplayIcon;
                            break;
                          case 3:
                            ItemIcon = ErrorOutlineIcon;
                            break;
                          default:
                            ItemIcon = ArticleIcon;
                        }

                        return (
                          <div key={index} className="term-list-item">
                            <ItemIcon className="list-item-icon" />
                            <p>{textItem}</p>
                          </div>
                        );
                      })}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Terms;
